/***
*
*   usePermissions hook
*   fetch, format and return the user permissions
*
**********/

import { useState, useEffect } from 'react';
import { useAPI } from 'components/lib';

const PERMISSION_LABELS = {
  master: "Propietario",
  owner: "Dueño",
  admin: "Administrador",
  user: "Usuario",
  developer: "Desarrollador",
  coordinator: "Coordinador",
  accounting: "Contable",
  driver: "Conductor",
  helper: "Asistente",
  assistant: "Auxiliar",
  guest: "Invitado",
};

function setPermissions(permission) {
  return PERMISSION_LABELS[permission] ?? (permission === null ? "Sin Permiso" : "Desconocido");
}

export function usePermissions(){

  const [state, setState] = useState({ data: null, loading: false });
  const permissions = useAPI('/api/user/permissions');

  useEffect(() => {

    setState({ loading: true });

    // format permissions
    if (permissions.data){

      let perms = [];
      Object.keys(permissions?.data).map(perm => {

        perms.push({ value: perm, label: setPermissions(perm) });
        setState({ data: { list: perms }, loading: false });
        return perms;

      });
    }
  }, [permissions]);

  return state;

}
